<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li class="tabLi" v-for="(data, $index) in langData" :key="$index" :class="{ 'active': $index == 0 }">
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a :class="true ? 'tab' + $index : ''" data-toggle="tab" :href="true ? '#tab-' + $index : ''" aria-expanded="true" @click="showTab($event, $index)">{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div :id="'tab-' + index" v-for="(langItem, index) in detailInfo.langMap" :key="index" class="tab-pane">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Section title </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMap.' + index + '.descriptionTitle'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="langItem.descriptionTitle" show-word-limit :maxlength="100"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Section description </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMap.' + index + '.sectionDescription'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input type="textarea" v-model="langItem.sectionDescription" show-word-limit :maxlength="500"></el-input>
                  </el-form-item>
                </div>
              </div>
              <el-table :data="rows" style="width: 100%" border ref="multipleTable">
                <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                <el-table-column prop="orderBy" label="Order" min-width="50"></el-table-column>
                <el-table-column prop="membershipCategoryId" label="Membership category" min-width="120"></el-table-column>
                <el-table-column prop="membershipName" label="Membership name" min-width="120"></el-table-column>
                <el-table-column prop="remark" label="Remark" min-width="120"></el-table-column>
                <el-table-column label="Enable " width="100">
                  <template slot-scope="scope">
                    <el-checkbox :disabled="checkNo >= 5 && !scope.row.check" v-model="scope.row.check" @change="changeCheck(scope.row)"></el-checkbox>
                  </template>
                </el-table-column>
              </el-table>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" v-if="checkPermission('MyWestK Privilege save')" @click="checkEvent()">
                      {{ $t("message.Save") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      rows: [],
      categoryList: [],
      checkNo: 0,
      detailInfo: {
        membershipId: [],
        langMap: [
          {
            langCode: "en_US",
            descriptionTitle: "",
            sectionDescription: "",
          },
          {
            langCode: "zh_CN",
            descriptionTitle: "",
            sectionDescription: "",
          },
          {
            langCode: "zh_HK",
            descriptionTitle: "",
            sectionDescription: "",
          },
        ],
      },
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    detailInfo: {
      handler: function (val, oldval) {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  components: {
    "file-upload": fileupload,
  },
  created() {
    this.setObj();
    this.init();
  },
  mounted() {
    setTimeout(function () {
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    });
  },
  methods: {
    setObj: function () {
      this.statusObj = [
        {
          value: "1",
          label: this.$i18n.t("message.Active"),
        },
        {
          value: "0",
          label: this.$i18n.t("message.Inactive"),
        },
      ];
    },
    async init() {
      let obj = this.getAuthObj();
      obj.apiUrl = "/getMemberMywestkPrivilegeDetail";
      let data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      if (data.data.result) {
        this.$set(this, "detailInfo", data.data.result);
      }
      var that = this;
      setTimeout(function () {
        that.$store.state.edit = false;
      });
      this.getMembership();
    },
    async getMembership() {
      let objdata = this.getAuthObj();
      objdata.sortField = "orderBy";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.apiUrl = "/getMembershipList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      objdata.apiUrl = "/getMembershipCategoryList";
      var data2 = await this.$store.dispatch("apiEvent", objdata);
      if (!data2) return;
      this.$set(this, "categoryList", data2.data);
      data.data.resultList.forEach(element => {
        this.categoryList.forEach(item => {
          if (element.membershipCategoryId == item.id) {
            element.membershipCategoryId = item.categoryCode;
            element.categoryType = item.categoryType;
          }
        });
        element.check = false;
        this.checkNo = 0;
        this.detailInfo.membershipId.forEach(item => {
          if (element.id == item) {
            element.check = true;
            this.checkNo++;
          }
        });
        element.membershipName = element.langMap[0].membershipName;
      });
      this.rows = data.data.resultList;
    },
    changeCheck(row) {
      this.checkNo = 0;
      this.rows.forEach(element => {
        if (element.check) {
          this.checkNo++;
        }
      });
    },
    checkEvent: function () {
      this.$refs["detailInfo"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        obj.memberShipIds = [];
        this.rows.forEach(element => {
          if (element.check) {
            obj.memberShipIds.push(element.id);
          }
        });
        obj.memberShipIds = obj.memberShipIds.join(",");
        obj.langMap = JSON.stringify(this.detailInfo.langMap);
        obj.apiUrl = "/saveMemberMywestkPrivilege";
        var data = await this.$store.dispatch("apiEvent", obj);

        if (!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.$toasted.success("Success.");
        }
      } catch (err) {}
    },
    changeTab: function (id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function ($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
  },
};
</script>
